export const itemColor = (pct: number, isFlagged = false): string => {
  if (isFlagged) return "var(--red)";
  if (pct >= 80) return "var(--green)";
  if (pct >= 60) return "var(--b)";
  if (pct >= 40) return "var(--amber)";
  if (pct > 0) return "var(--red)";
  return "var(--tx3)";
};
